<template>
  <pt-old-to-new-detail class="pt-old-to-new-detail__page" :id="id" :type="type"></pt-old-to-new-detail>
</template>

<script>
import PtOldToNewDetail from 'cps/mall-manage/pt-old-to-new/pt-old-to-new-detail/withData'
export default {
  name: 'pt-old-to-new-detail__view',
  components: {
    'pt-old-to-new-detail': PtOldToNewDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  }
}
</script>
